import React from 'react'

import POEntityDetailPage from '@/components/views/ci/PO/POEntityDetailPage'

const PO_IS_POEntityDetailPage = () => {
    return <POEntityDetailPage />
}

export default PO_IS_POEntityDetailPage
